module.exports = __webpack_public_path__ + "img/can5.d3eac131.png";